<template>
 <div>
  <v-form v-if="!loading" class="ma-2" ref="form" v-model="valid" lazy-validation>
    <v-card>
      <v-system-bar>
        <span>Validate / Beoordeling</span>
      </v-system-bar>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="8" sm="12" md="8">
              <v-card>
                <v-card-title>{{ identity.profile.name }} / {{ identity.profile.description }}</v-card-title>
                <v-simple-table>
                  <template v-slot:default>
                    <tbody>
                      <tr v-if="identity.organization">
                        <td class="subtitle-2">Organisatie / Organization</td>
                        <td>{{ identity.organization.name }}</td>
                      </tr>
                      <tr>
                        <td class="subtitle-2">Naam / Name</td>
                        <td>{{ identityPerson(identity).givenName + ' ' + (identityPerson(identity).surnamePrefix ? ' ' + identityPerson(identity).surnamePrefix : '') + ' ' + identityPerson(identity).surname }}</td>
                      </tr>
                      <tr>
                        <td class="subtitle-2">Startdatum / Start date</td>
                        <td>{{ $moment.utc(identity.startDate).local().format('dddd D MMM YYYY HH:mm') }}</td>
                      </tr>
                      <tr>
                        <td class="subtitle-2">Einddatum / End date</td>
                        <td v-if="identity.endDate">{{ $moment.utc(identity.endDate).local().format('dddd D MMM YYYY HH:mm') }}</td>
                      </tr>
                      <tr>
                        <td class="subtitle-2">Status</td>
                        <td>{{ statusIdToName(identity.status, true) }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card>
            </v-col>
            <v-col cols="4" sm="12" md="4">
              <v-card :color="blockadeListStatusColor">
                <v-card-title>Blockade</v-card-title>
                <v-card-text>
                  <div v-if="identity.lookupResults && identity.lookupResults.length > 0 && identity.lookupResults[0].hasResults">
                    <div v-for="match in identity.lookupResults[0].matches" :key="match.key">
                      <div class="caption font-weight-medium" style="line-height:1.1rem;" v-html="showMatch(match.value)"></div>
                    </div>
                  </div>
                  <div class="caption font-weight-medium" v-if="identity.lookupResults && identity.lookupResults.length > 0 && identity.lookupResults[0].status > 0">Error processing lookup</div>
                  <div class="caption font-weight-medium" v-if="identity.lookupResults && identity.lookupResults.length > 0 && !identity.lookupResults[0].hasResults">Geen / None</div>
                  <div class="caption font-weight-medium" v-if="!identity.lookupResults || identity.lookupResults.length == 0">Onbekend / Unknown</div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-card color="#eeeeee">
                <v-card-text>
                  <v-row>
                    <v-col cols="12" v-for="step in identity.profile.steps" :key="step.id">
                      <v-card xs12 class="mx-auto" v-if="showStepDocuments(step)">
                        <v-container class="pt-0 mt-0" fluid>
                          <v-row>
                            <v-col cols="12">
                              <div class="mb-2" v-for="field in step.fields" :key="field.id">
                                <v-tooltip top v-if="field.type == 38 && showStepDocumentsField(field) && documentsList && documentsDates">
                                  <template v-slot:activator="{ on }">
                                    <v-row>
                                      <v-col cols="8" class="pt-6" v-if="!field.value">
                                        <v-btn small v-on="on" @click="openFileDialog(field)">
                                          Upload {{getDocumentTypeNameById(field.name)}}
                                          <v-icon right dark> cloud_upload</v-icon>
                                        </v-btn>
                                        <input type="file" :id="field.id" style="display:none" @change="onFileChange">
                                      </v-col>
                                      <v-col cols="8" class="pt-6" v-else>
                                          <v-btn small v-bind:color="getValidationColor(field)" v-on="on" @click="openPdf(field)">
                                            {{getDocumentTypeNameById(field.name)}}
                                            <v-icon right dark>check</v-icon>
                                          </v-btn>
                                          <v-btn small class="ml-2" color="error" @click.stop="documentsDates.find(x => x.id == field.id).deleteDialog = true">
                                            <v-icon dark>delete</v-icon>
                                          </v-btn>
                                          <v-dialog
                                            v-model="documentsDates.find(x => x.id == field.id).deleteDialog"
                                            max-width="290">
                                          <v-card>
                                            <v-card-title class="subtitle-2">Weet u zeker dat u wilt verwijderen? /<br />Are you sure you want to delete?</v-card-title>
                                              <v-divider></v-divider>
                                              <br />
                                              <v-card-text>
                                                <v-btn class="float-right" @click="documentsDates.find(x => x.id == field.id).deleteDialog = false">cancel</v-btn>
                                                <v-btn color="primary" @click="deleteFile(field)">ok</v-btn>
                                              </v-card-text>
                                          </v-card>
                                        </v-dialog>
                                        <v-radio-group row hide-details
                                          v-model="documentsDates.find(x => x.id == field.id).validated"
                                          @change="setValidation(field, $event)"
                                          label="Goedkeuren: "
                                          :disabled="documentsList.find(d => d.type.id == field.name).type.validationRequired == false"
                                        >
                                        <v-radio color="success" label="Goedgekeurd" value="true"></v-radio>
                                        <v-radio color="error" label="Afgekeurd" value="false"></v-radio>
                                      </v-radio-group>  
                                      </v-col>
                                      <v-col cols="4" v-if="!pdfField && documentsList && documentsList.find(x => x.type.id == field.name).type.expirationDateRequired">
                                        <template>
                                          <v-menu
                                            v-model="documentsDates.find(x => x.id == field.id).datemenu"
                                            :close-on-content-click="false"
                                            transition="scale-transition"
                                            offset-y
                                            max-width="290px"
                                            min-width="290px">
                                            <template v-slot:activator="{ on }">
                                              <v-text-field
                                                :value="computedStartDateFormatted"
                                                v-model="documentsDates.find(x => x.id == field.id).dateFormatted"
                                                :required="field.value && field.value != ''"
                                                :rules="getRule(field.type, (field.value && field.value != ''))"
                                                v-bind:label="'Vervaldatum' + (field.value && field.value != '' ? ' *': '')"
                                                prepend-icon="event"
                                                @blur="documentsDates.find(x => x.id == field.id).date = parseDate(documentsDates.find(x => x.id == field.id).dateFormatted)"
                                                v-on="on"
                                                autocomplete="off"
                                              ></v-text-field>
                                            </template>
                                            <v-date-picker
                                              :locale="$moment.locale()"
                                              v-model="documentsDates.find(x => x.id == field.id).date"
                                              no-title
                                              @input="documentsDatePicker(field)"
                                            ></v-date-picker>
                                          </v-menu>
                                        </template>
                                      </v-col>
                                    </v-row>
                                  </template>
                                  <span>{{field.description}}</span>
                                </v-tooltip>
                              </div>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card>
                    </v-col>
                    <v-col cols="12">
                      <template>
                        <v-textarea v-model="note" label="Opmerking" auto-grow rows="1"></v-textarea>
                      </template>
                    </v-col>
                    <v-col cols="12">
                      <v-btn class="ma-2 float-right" @click="cancel">annuleer / cancel</v-btn>
                      <v-btn
                        class="ma-2"
                        color="success"
                        @click="submit(statusNameToId('Validation'))"
                        :disabled="!valid || !isComplete()"
                      >verder / proceed</v-btn>
                      <v-btn 
                        class="ma-2"
                        color="error"
                        @click="submit(statusNameToId('Revoked'))"
                        :disabled="isComplete()"
                      >afwijzen / decline</v-btn>
                      <span>{{submitStatus}}</span>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
              <br />
              <v-card>
                <v-list>
                  <v-list-group>
                    <template v-slot:activator>
                      <v-list-item-title>Details</v-list-item-title>
                    </template>
                    <v-list-item>
                      <v-list-item-content>
                        <v-card v-for="step in identity.profile.steps" :key="step.id">
                          <template v-if="!step.isValidationStep">
                          <v-card-title>{{ step.name }}</v-card-title>
                          <v-card-text>
                            <v-simple-table>
                              <template v-slot:default>
                                <tbody>
                                  <tr v-for="field in step.fields" :key="field.id" >
                                    <template v-if="(field.type == 3 || field.type == 21) && field.value != null">
                                      <td  width="50%">{{ field.name }}</td>
                                      <td>{{ $moment.utc(field.value).local().format("DD-MM-YYYY") }}</td>
                                    </template>
                                    <template v-else-if="field.type == 20">
                                      <td width="50%">{{ field.name }}:</td>
                                      <td>{{ sexesIdToName(field.value, true) }}</td>
                                    </template>
                                    <template v-else-if="field.type == 38 && field.value != null">
                                      <td width="50%">{{ getDocumentTypeNameById(field.name) }}</td>
                                      <td>{{ getDocumentDateById(field.name) }}</td>
                                    </template>
                                    <template v-else-if="field.type != 38">
                                      <td width="50%">{{ field.name }}:</td>
                                      <td>{{ showValue(field.value) }}</td>
                                    </template>
                                  </tr>
                                </tbody>
                              </template>
                            </v-simple-table>
                          </v-card-text>
                          </template>
                        </v-card>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-group>
                  <v-list-group v-if="identity && identity.events">
                      <template v-slot:activator>
                        <v-list-item-title>Audit Trail</v-list-item-title>
                      </template>
                      <v-list-item>
                        <v-list-item-content>
                          <v-card>
                            <v-simple-table dense>
                              <template v-slot:default>
                                <thead>
                                  <tr>
                                    <th class="text-left">Date/time</th>
                                    <th class="text-left">ModifiedBy</th>
                                    <th class="text-left">Action</th>
                                    <th class="text-left">Message</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="item in identity.events" :key="item.id">
                                    <td>{{ $moment.utc(item.created).local().format("DD-MM-YYYY HH:mm:ss") }}</td>
                                    <td>{{ (item.modifiedBy.surnamePrefix ? item.modifiedBy.surnamePrefix + " " : "") +  item.modifiedBy.surname }}</td>
                                    <td>{{ item.action }}</td>
                                    <td>{{ item.message }}</td>
                                  </tr>
                                </tbody>
                              </template>
                            </v-simple-table>
                          </v-card>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-group>
                </v-list>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-form>
  <v-dialog fullscreen
      v-model="pdfDialog"
      persistent 
    >
      <v-card>
         <v-toolbar dark color="primary">
          <v-btn icon dark @click="closePdfDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ this.pdfField ? this.getDocumentTypeNameById(this.pdfField.name) : '' }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="savePdfDialog">Bewaar / Save</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-row>
            <v-col cols="2"><p class="subtitle-2">Pagina / Page: {{pdfCurrentPage}} <br />Totaal / Total: {{pdfPageCount}}</p></v-col>
            <v-col cols="4">
                <v-btn color="primary mr-2" fab small dark @click="pdfPrev">
                  <v-icon>mdi-skip-previous</v-icon>
                </v-btn>
                <v-btn color="primary mr-2" fab small dark @click="pdfNext">
                  <v-icon>mdi-skip-next</v-icon>
                </v-btn>
                
                <v-btn color="primary mr-2" fab small dark @click="pdfRight">
                  <v-icon>mdi-rotate-right</v-icon>
                </v-btn>
                <v-btn color="primary mr-2" fab small dark @click="pdfLeft">
                  <v-icon>mdi-rotate-left</v-icon>
                </v-btn>
            </v-col>
            <v-col cols="2">
              <v-btn color="primary" dark @click="downloadFile">
                <v-icon>cloud_download</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="4" v-if="pdfField && documentsList && documentsList.find(x => x.type.id == pdfField.name).type.expirationDateRequired">
                                        <template>
                                          <v-menu
                                            v-model="documentsDates.find(x => x.id == pdfField.id).datemenu"
                                            :close-on-content-click="false"
                                            transition="scale-transition"
                                            offset-y
                                            max-width="290px"
                                            min-width="290px">
                                            <template v-slot:activator="{ on }">
                                              <v-text-field
                                                :value="computedStartDateFormatted"
                                                v-model="documentsDates.find(x => x.id == pdfField.id).dateFormatted"
                                                :required="pdfField.value && pdfField.value != ''"
                                                :rules="getRule(pdfField.type, (pdfField.value && pdfField.value != ''))"
                                                v-bind:label="'Vervaldatum' + (pdfField.value && pdfField.value != '' ? ' *': '')"
                                                prepend-icon="event"
                                                @blur="documentsDates.find(x => x.id == pdfField.id).date = parseDate(documentsDates.find(x => x.id == pdfField.id).dateFormatted)"
                                                v-on="on"
                                                autocomplete="off"
                                              ></v-text-field>
                                            </template>
                                            <v-date-picker
                                              :locale="$moment.locale()"
                                              v-model="documentsDates.find(x => x.id == pdfField.id).date"
                                              no-title
                                              @input="documentsDatePicker(pdfField)"
                                            ></v-date-picker>
                                          </v-menu>
                                        </template>
                                      </v-col>
          </v-row>
        </v-card-text>
        <v-card-text>
          <v-sheet>
            <pdf style="width:100%; border: 1px solid red;"
            v-if="pdfDialog"
            ref="pdf" 
            :src="pdfTemp"
            @num-pages="pdfPageCount = $event"
            :page="pdfCurrentPage"
            :rotate="pdfRotate"
          ></pdf>
          </v-sheet>
        </v-card-text>
        <div style="height:550px;"></div>
      </v-card>
    </v-dialog>
 </div>
</template>

<script>
import pdf from "vue-pdf";
export default {
  props: ["identity", "me"],
  components: {
    pdf
  },
  data: () => ({
    loading: false,
    submitStatus: null,
    note: "",
    startDate: new Date().toISOString().substr(0, 10),
    valid: false,
    nameRules: [
      v => !!v || "This field is required",
      v => (v && v.length <= 100) || "100 characters maximum"
    ],
    pdfDialog: false,
    pdfField: null,
    pdfOldDate: null,
    pdfTemp: null,
    pdfCurrentPage: 1,
    pdfPageCount: 0,
    pdfRotate: 0,
    fieldsDates: null,
    documentTypes: [],
    documentsExist: false,
    documentsStep: 0,
    documentsList: null,
    documentsDates: null,
    documentsSelected: [],
    uploadField: null,
  }),
  computed: {
    computedStartDateFormatted() {
      return this.startDate
        ? this.$moment.utc(this.startDate).format("ddd D MMM YYYY")
        : "";
    },
    blockadeListStatusColor() {
      let status = 'warning';
      if (this.identity.lookupResults && this.identity.lookupResults.length > 0) {
        if (this.identity.lookupResults[0].hasResults) {
          status = 'error'
        }
        else {
          if (this.identity.lookupResults[0].status == 0) {
            status = 'success'
          }
        }
      }
      return status;
    }
  },
  methods: {
    showMatch(val) {
      let matchstring = "<table>";
      var arr_match = val.split(';');
      arr_match.forEach(m => {
        var arr_kv = m.split('=');
        matchstring += "<tr><td style='vertical-align:top;padding-right:11px;'>" + arr_kv[0] + 
        "</td><td style='vertical-align:top;'>" + arr_kv[1] + "</td></tr>";
      });
      return matchstring + "</table>";
    },
    showValue(val) {
      if (val == "true") return "Ja / Yes";
      else if (val == "false") return "Nee / No";
      else return val;
    },
    showStepDocuments(step) {
      var docs = false;
      step.fields.forEach(stepField => {
        if (stepField.type == 38) docs = true;
      });
      if (this.documentsExist) {
        if (this.documentsStep == 0) return !docs;
          else return docs;
      } else return true;
    },
    showStepDocumentsField(field) {
      if (this.documentsList) {
        var i = this.documentsList.find(d => d.type.id == field.name);
        return i.personId != null;
      }
      else {
        return false;
      }
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split("-");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    submit(status) {
      this.$parent.loading = true;
      if (status != this.statusNameToId('Revoked') && (!this.$refs.form.validate() || !this.isComplete())) {
        this.submitStatus = "ERROR";
        this.$parent.loading = false;
      } else {
        this.submitStatus = "POSTING";
        this.identity.profile.steps.forEach(step => {
          step.fields.forEach(stepField => {
            if (stepField.type == 21 && this.date != null) {
              stepField.value = this.date;
            }  else if (stepField.type == 3 && this.documentsStep == 2) {
                var fieldDate = this.fieldsDates.find(d => d.id == stepField.id).date;
                stepField.value = fieldDate ? fieldDate : '';
            }
            else if (stepField.type == 38) {
              var docDate = this.documentsDates.find(x => x.id == stepField.id).date;
              this.documentsList.find(x => x.type.id == stepField.name).expirationDate = docDate ? docDate : '';
              if (this.showStepDocumentsField(stepField)) {
                  this.documentsSelected.push(this.documentsList.find(x => x.type.id == stepField.name));
              }
            }
          });
        });
        this.identity.status = status;
        let indentityView = {
          identity: this.identity,
          documents: this.documentsSelected,
          note: this.note
        };
        this.$http
          .post("api/identities/", indentityView)
          .then(request => {
            if (request.status == 201) {
              this.submitStatus = "";
              this.$parent.processorResult = request.data;
            } else {
              this.submitStatus = "ERROR";
              this.$parent.loading = false;
            }
          })
          .catch(e => {
            this.$root.$children[0].$emit("display-error", "1600", e);
            this.submitStatus = "ERROR";
            this.$parent.loading = false;
          });
      }
    },
    cancel() {
      this.$emit("done");
    },
    statusIdToName(id, nl) {
      if (this.$root.$children[0]) {
        return this.$root.$children[0].getIdentityStatusName(id, nl);
      }
      else return "";
    },
    onFileChange(e) {
      this.newFileForm = new FormData();
      var files = e.target.files || e.dataTransfer.files;
      if(files.length > 0){
        this.newFileName = files[0].name;
        this.newFileForm.append("file", files[0], files[0].name);
      }
      if(e) {
        this.$http
          .post("api/appfile/", this.newFileForm, {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          })
          .then(request => {
            if (request.status == 201) {
              if (!this.uploadField) this.$root.$children[0].$emit("display-error", "1603", "onFileChange: no file upload initialized");
              var uploadStep = this.identity.profile.steps.find(s => s.id === this.uploadField.stepId);
              if (!uploadStep) this.$root.$children[0].$emit("display-error", "1604", "onFileChange: no step found");
              var uploadField = uploadStep.fields.find(f => f.id === this.uploadField.id);
              if (!uploadField)  this.$root.$children[0].$emit("display-error", "1605", "onFileChange: no field found");
              uploadField.value = request.data;
            }
          })
          .catch(err => {
            this.$root.$children[0].$emit("display-error", "1601", err);
          });
      } else {
        this.$root.$children[0].$emit("display-error", "1602", "no file selected");
      }
    },
    openFileDialog(field) {
      this.uploadField = field;
      document.getElementById(field.id).click();
    },
    deleteFile(field) {
      if (this.documentsDates && this.documentsList) {
        field.value = null;
        this.documentsDates.find(d => d.id == field.id).date = null;
        this.documentsDates.find(d => d.id == field.id).dateFormatted = '';
        this.documentsDates.find(d => d.id == field.id).validated = false;
        this.documentsList.find(d => d.type.id == field.name).isValidated = false;
        this.documentsDates.find(x => x.id == field.id).deleteDialog = false;
      }
      this.uploadField = null;
    },
    openPdf(field) {
      this.pdfField = field;
      this.pdfOldDate = this.documentsDates.find(d => d.id == field.id).date;
      this.$http
        .get("api/appfile/" + field.value)
        .then(request => {
          if (request.status == 200) {
            var blob = this.base64toBlob(request.data.data, "application/pdf");
            this.pdfTemp = URL.createObjectURL(blob);
            this.pdfDialog = true;
          }
        })
        .catch(err => {
          this.$root.$children[0].$emit("display-error", "1606", err);
        });
    },
    setValidation(field, event){
      if (this.documentsList && this.documentsList.find(d => d.type.id == field.name)) {
        if (event.toString() == "true")
          this.documentsList.find(d => d.type.id == field.name).isValidated = true;
        else if (event.toString() == "false")
          this.documentsList.find(d => d.type.id == field.name).isValidated = false;
      }
    },
    isComplete() {
      var complete = true;
      if (this.documentsDates && this.documentsList) {
        this.documentsDates.forEach(date => {
          if (date.docTypeId != 0) {
            if (date.date == null && this.documentsList.find(d => d.type.id == date.docTypeId).type.expirationDateRequired == true ||
                (this.documentsList.find(d => d.type.id == date.docTypeId).isValidated == false ||
                this.documentsList.find(d => d.type.id == date.docTypeId).isValidated == null) && 
                this.documentsList.find(d => d.type.id == date.docTypeId).type.validationRequired == true)
                  complete = false;
          }
        });
      }
      return complete;
    },
    downloadFile() {
      var id = this.pdfField.value;
      var filename = this.getDocumentTypeNameById(this.pdfField.name);
      this.$http
        .get("api/appfile/" + id)
        .then(request => {
          if (request.status == 200) {
            var blob = this.base64toBlob(request.data.data, "application/pdf");
            setTimeout(() => {
              if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(
                  blob,
                  filename+'-'+id
                );
              } else {
                return this.downloadClick(blob, filename+'-'+id);
              }
            }, 0);            
          }
        })
        .catch(e => {
          this.$root.$children[0].$emit("display-error", "1607", e);
        });      
    },
    downloadClick (blob, filename) {
      var a = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display: none";      
      var url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = filename;
      a.click();
      window.URL.revokeObjectURL(url);
    },
    base64toBlob(b64Data, contentType) {
      contentType = contentType || "";
      var sliceSize = 1024;
      var byteCharacters = atob(b64Data);
      var bytesLength = byteCharacters.length;
      var slicesCount = Math.ceil(bytesLength / sliceSize);
      var byteArrays = new Array(slicesCount);

      for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
        var begin = sliceIndex * sliceSize;
        var end = Math.min(begin + sliceSize, bytesLength);

        var bytes = new Array(end - begin);
        for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
          bytes[i] = byteCharacters[offset].charCodeAt(0);
        }
        byteArrays[sliceIndex] = new Uint8Array(bytes);
      }
      return new Blob(byteArrays, { type: contentType });
    },
    pdfPrev() {
      if (this.pdfPageCount > 2)
        this.pdfCurrentPage--;
    },
    pdfNext() {
      if (this.pdfCurrentPage < this.pdfPageCount)
        this.pdfCurrentPage++;
    },
    pdfRight() {
      if (this.pdfRotate < 270)
        this.pdfRotate += 90;
    },
    pdfLeft() {
      if (this.pdfRotate > -270)
        this.pdfRotate -= 90;
    },
    closePdfDialog() {
      if (this.pdfField && this.documentsDates) {
        this.documentsDates.find(d => d.id == this.pdfField.id).date = this.pdfOldDate;
        this.documentsDates.find(d => d.id == this.pdfField.id).dateFormatted = this.formatDate(this.documentsDates.find(d => d.id == this.pdfField.id).date);
      }
      this.savePdfDialog()
    },
    savePdfDialog() {
      this.pdfOldDate = null;
      this.pdfField = null;
      this.pdfTemp = null;
      this.pdfDialog = false;
    },
    getDocumentTypes() {
      this.$http
        .get("api/documenttypes/")
        .then(request => {
          if (request.status == 200) {
            this.documentTypes = request.data;
            this.analyseProfile();
          }
        })
        .catch(e => {
          this.$root.$children[0].$emit("display-error", "1608", e);
        });
    },
    analyseProfile() {
      this.documentsStep = 0;
      this.documentsList = [];
      this.documentsDates = [];
      this.fieldsDates = [];
      this.documentsSelected = [];
      
      this.identity.profile.steps.forEach(step => {
        step.fields.forEach(stepField => {
          if (stepField.type == 38) {
            this.documentsExist = true;
            var type = this.documentTypes.find(x => x.id == stepField.name);
            this.documentsList.push({type: type, expirationDate: null, isValidated: null});
            this.documentsDates.push({id: stepField.id, datemenu: false, date: null, dateFormatted: "", docTypeId: 0, validated: "null", deleteDialog: false});
          }
          else if(stepField.type == 3) {
              this.fieldsDates.push({id: stepField.id, datemenu: false, date: null, dateFormatted: ""});
          }
        });
      });
      if (this.identity.person) {
        if (this.identity.person.documents && this.identity.person.documents.length > 0) {
          this.documentsExist = true;
          this.documentsStep = 2;
          this.identity.person.documents.forEach(doc => {
            var i = this.documentsList.findIndex(d => d.type.id == doc.type.id);
            this.documentsList[i] = doc;
            if (doc.expirationDate) {
              this.documentsDates[i].date = this.$moment.utc(doc.expirationDate).local().format("YYYY-MM-DD");
              this.documentsDates[i].dateFormatted = this.formatDate(this.documentsDates[i].date);
            }
            this.documentsDates[i].docTypeId = doc.type.id;
            this.documentsDates[i].validated = doc.isValidated != null ? doc.isValidated.toString() : "null";
          });
        }
      }
    },
    getValidationColor(field){
      if ((this.documentsList && 
        this.documentsList.find(d => d.type.id == field.name)) && (
        (this.documentsList.find(d => d.type.id == field.name).isValidated != null &&
        this.documentsList.find(d => d.type.id == field.name).isValidated == true) ||
        this.documentsList.find(d => d.type.id == field.name).type.validationRequired == false))
        return 'success';
      else if ((this.documentsList && 
        this.documentsList.find(d => d.type.id == field.name)) && (
        (this.documentsList.find(d => d.type.id == field.name).isValidated != null &&
        this.documentsList.find(d => d.type.id == field.name).isValidated == false)))
        return 'error';
      else
        return 'warning';
    },
    getDocumentTypeNameById(id) {
      var result = '';
      if (this.documentTypes) result = this.documentTypes.find(x => x.id === id).name;
      return result;
    },
    getDocumentDateById(id) {
      if (this.documentsExist) {
        if (this.identity && this.identity.person && this.identity.person.documents) {
          var date = this.identity.person.documents.find(x => x.type.id == id).expirationDate;
          if (date != null)
            return this.$moment.utc(date).local().format("DD-MM-YYYY");
        }
      }
      return '';
    },
    getRule(type, isRequired) {
      if (type == "27" || type == "39") {
        if (isRequired) return this.emailRules;
        else return this.emailOptionalRules;
      }
      else if (type == "28") {
        if (isRequired) return this.autoRules;
      }
      else if (type == "4") return this.numberOptionalRules;
      else {
        if (isRequired) return this.nameRules;
      }
    },
    documentsDatePicker(field) {
      this.documentsDates.find(d => d.id == field.id).datemenu = false;
      this.documentsDates.find(d => d.id == field.id).dateFormatted = this.formatDate(this.documentsDates.find(d => d.id == field.id).date);
    },
    fieldsDatePicker(id) {
      this.fieldsDates.find(f => f.id == id).datemenu = false;
      this.fieldsDates.find(f => f.id == id).dateFormatted = this.formatDate(this.fieldsDates.find(f => f.id == id).date);
    },
    sexesIdToName(id, nl) {
      if (this.$root.$children[0]) {
        return this.$root.$children[0].getSexesName(id, nl);
      }
      else return "";
    },
    statusNameToId(name) {
      if (this.$root.$children[0]) {
        return this.$root.$children[0].getIdentityStatusId(name);
      }
      else return "";
    },
    identityPerson(ident) {
      let person = { givenName:"", surnamePrefix:"", surname:"" };
      if (ident.sets && ident.sets[0].fields) {
        ident.sets[0].fields.forEach(f => {
          if (f.type == 10)
            person.givenName = f.value;
          else if (f.type == 13)
            person.surnamePrefix = f.value;
          else if (f.type == 14)
            person.surname = f.value;
        })
      }
      return person;
    }
  },
  mounted: function() {
    this.getDocumentTypes();
  }
};
</script>